// extracted by mini-css-extract-plugin
export default {"commonBanner":"CommonBanner_commonBanner__-rVLI"};